import { wizardStepType } from "../../type";
import { BrowserFile } from "./steps/browserFile";
import { FunctionMap } from "./steps/functionMap";

const Container = (props: any) => {
  const {
    app,
    currentStep,
    fileUpload,
    onFileUpdate,
    refresh,
    onFileUpdateRefresh,
    selectedFunction,
    isMultipleFileAllowed
  } = props;
  return (
    <div className="wizard-container">

      {currentStep === wizardStepType.BrowserFile && (
        <BrowserFile fileUpload={fileUpload} onFileUpdate={onFileUpdate} onFileUpdateRefresh={onFileUpdateRefresh} isMultipleFileAllowed={isMultipleFileAllowed} />
      )}

      {currentStep === wizardStepType.FunctionMap && (
        <FunctionMap
          fileUpload={fileUpload}
          onFileUpdate={onFileUpdate}
          refresh={refresh}
          selectedFunction={selectedFunction}
          app={app}
        />
      )}
      
    </div>
  );
};
export { Container };